import { API_URL } from "@/constants/envVariables";

import { handleApiResponse } from "@/api/handleApiResponse";

import { buildAuthHeaders, getAuthCredentials } from "@/helpers/authHeaders";

import { ApiKey } from "@/types";

export const getApiKey = async (token: string, apiKeyId: string): Promise<ApiKey> => {
  const response = await fetch(`${API_URL}/api-keys/${apiKeyId}`, {
    method: "GET",
    credentials: getAuthCredentials(),
    headers: {
      "Content-Type": "application/json",
      ...buildAuthHeaders(token),
    },
  });

  return handleApiResponse(response);
};
